import { Maybe } from './globalTypes'

import imageDiffFragmentRawString from '../../fragments/ImageDiffFragment.graphql'

export const imageDiffFragmentString = imageDiffFragmentRawString

export type ImageDiffFragment = {
  __typename: 'ComponentSharedImageDiff'
  id: string
  leftImage: {
    url: string
  }
  leftAlt: Maybe<string>
  rightImage: {
    url: string
  }
  rightAlt: Maybe<string>
}

export const isImageDiffFragment = (
  fragment: any,
): fragment is ImageDiffFragment =>
  fragment &&
  fragment.__typename === 'ComponentSharedImageDiff' &&
  typeof fragment.id === 'string' &&
  fragment.leftImage &&
  typeof fragment.leftImage.url === 'string' &&
  (fragment.leftAlt === null || typeof fragment.leftAlt === 'string') &&
  fragment.rightImage &&
  typeof fragment.rightImage.url === 'string' &&
  (fragment.rightAlt === null || typeof fragment.rightAlt === 'string')
